export function initBfDiscountGridSlider(root: ParentNode = document): void {
  const containers = root.querySelectorAll<HTMLElement>('[id^="bf-discount-slider-"]');
  if (!containers.length) return;

  for (const container of Array.from(containers)) {
    if (container.dataset.bfDiscountSliderInit === '1') continue;
    container.dataset.bfDiscountSliderInit = '1';

    const sectionId = container.id.replace('bf-discount-slider-', '');
    if (!sectionId) continue;

    const prevButton = root.querySelector<HTMLButtonElement>(`.bf-discount-slider-prev-${sectionId}`);
    const nextButton = root.querySelector<HTMLButtonElement>(`.bf-discount-slider-next-${sectionId}`);

    if (!prevButton || !nextButton) continue;

    const scrollAmount = 300;
    const updateButtons = () => {
      const { scrollLeft, scrollWidth, clientWidth } = container;
      const canScroll = scrollWidth > clientWidth;
      const isAtStart = scrollLeft <= 1;
      const isAtEnd = scrollLeft >= scrollWidth - clientWidth - 1;

      if (!canScroll) {
        // Hide arrows completely when content doesn't overflow (using visibility to preserve responsive classes)
        prevButton.style.visibility = 'hidden';
        prevButton.style.opacity = '0';
        prevButton.style.pointerEvents = 'none';
        nextButton.style.visibility = 'hidden';
        nextButton.style.opacity = '0';
        nextButton.style.pointerEvents = 'none';
        return;
      }

      // Show arrows when content is scrollable
      prevButton.style.visibility = '';
      nextButton.style.visibility = '';

      prevButton.style.opacity = isAtStart ? '0.3' : '0.6';
      prevButton.style.pointerEvents = isAtStart ? 'none' : 'auto';
      nextButton.style.opacity = isAtEnd ? '0.3' : '0.6';
      nextButton.style.pointerEvents = isAtEnd ? 'none' : 'auto';
    };

    prevButton.addEventListener('click', () => {
      container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    nextButton.addEventListener('click', () => {
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    container.addEventListener('scroll', updateButtons, { passive: true });
    
    // Use ResizeObserver to handle dynamic content changes
    const resizeObserver = new ResizeObserver(() => {
      // Use requestAnimationFrame to ensure layout is complete
      requestAnimationFrame(updateButtons);
    });
    resizeObserver.observe(container);
    
    // Initial update with a small delay to ensure layout is complete
    requestAnimationFrame(() => {
      updateButtons();
    });
  }
}

